import Plyr from 'plyr';

const toggleOverlay = (iframe, player,) => {
  player.querySelector("[data-poster]").classList.add("hidden")
  player.querySelector(".play-icon").classList.add("hidden")
  player.classList.remove("first")
  iframe.classList.remove("hidden")
}

const players = document.querySelectorAll(".plyr-container");

if (players.length > 0) {
  // if player on page, load css
  const plyrCss = document.querySelector("[data-plyr-css]")
  if (!plyrCss.getAttribute('href')) {
    plyrCss.setAttribute('href', plyrCss.getAttribute('data-plyr-css'))
  }

  players.forEach(player => {
    const iframe = player.querySelector("iframe")
    const iframeUrl = iframe.getAttribute('data-embed-url')
    
    player.addEventListener("click", () => {
      // if the player is clicked for the first time, create the Plyr player
      if (player.classList.contains("first")) {
        iframe.setAttribute('src', iframeUrl)
        const newPlayer = new Plyr("#player", {
          ratio: '16:9',
        })
        
        
        newPlayer.on('ready', () => {
          toggleOverlay(iframe, player)
          newPlayer.play();
        });
        
        toggleOverlay(iframe, player)
      }
    })
  });
}